module.exports = __webpack_public_path__ + "media/application/images/icons/toc-c18a868ce48e2e680ede8b7bc9733846.svg";